interface PortraitProps {
  kind: 'hero-landscape' | 'hero-portrait' | 'about' | 'profile' | 'editorial-bw'
  alt?: string
  className?: string
  loading?: 'eager' | 'lazy'
}

const dimensions = {
  'hero-landscape': [3024, 2016],
  'hero-portrait': [3024, 3780],
  about: [3024, 3780],
  profile: [3024, 3024],
  'editorial-bw': [3024, 4032],
} as const

const responsiveKinds = new Set(['hero-landscape', 'hero-portrait', 'about', 'profile', 'editorial-bw'])

const stemByKind = {
  'hero-landscape': 'michael-kidd-square-compass-notary-hero-landscape',
  'hero-portrait': 'michael-kidd-square-compass-notary-hero-portrait',
  about: 'michael-kidd-square-compass-notary-about',
  profile: 'michael-kidd-square-compass-notary-profile',
  'editorial-bw': 'michael-kidd-square-compass-notary-bw-02',
} as const

export function Portrait({
  kind,
  alt = 'Michael Kidd, owner of Square & Compass Notary.',
  className,
  loading = 'lazy',
}: PortraitProps) {
  const [width, height] = dimensions[kind]
  const stem = stemByKind[kind]
  const widths = responsiveKinds.has(kind) ? [480, 768, 1024, 1280] : [480, 768]
  const srcSet = (format: 'avif' | 'webp') =>
    widths
      .map((candidate) => `/images/michael/${stem}-${candidate}w.${format} ${candidate}w`)
      .join(', ')

  return (
    <picture className={className}>
      <source type="image/avif" srcSet={srcSet('avif')} sizes="(min-width: 960px) 50vw, 100vw" />
      <source type="image/webp" srcSet={srcSet('webp')} sizes="(min-width: 960px) 50vw, 100vw" />
      <img
        src={`/images/michael/${kind}.jpg`}
        alt={alt}
        width={width}
        height={height}
        loading={loading}
        decoding="async"
      />
    </picture>
  )
}
